import {getHiddenDimensions} from "./Util";

class SmartBreadcrumbs {
	constructor( smartBreadcrumbsEl ) {
		this.root = smartBreadcrumbsEl;
		this.addEllipsis();
		this.items =  this.root.querySelectorAll( '.breadcrumb_item' );

		if( this.items.length < 3 ) return;

		this.magicLogic();
		window.addEventListener( 'resize', () => { this.magicLogic(); } );
	}

	addEllipsis() {
		const ellipsisLi = document.createElement( 'li' );
		ellipsisLi.className = 'breadcrumb_item en_hidden';
		ellipsisLi.innerHTML = '…';
		this.root.querySelectorAll( '.breadcrumb_item' )[0].after( ellipsisLi );
	}

	magicLogic() {
		let allItems = Array.from( this.items );
		let variableItems = allItems.slice( 2 );
		const homeItem = allItems[0];
		const ellipsisItem = allItems[1];

		let width = this.root.clientWidth - homeItem.offsetWidth - getHiddenDimensions( ellipsisItem ).outerWidth;
		let trimCount = 0;
		variableItems = variableItems.reverse();

		variableItems.forEach( ( item, index ) => {
			item.classList.remove( 'en_hidden' );
			width -= item.offsetWidth;

			if ( width < 0 && index !== 0 ) {
				trimCount++;
				item.classList.add( 'en_hidden' );
			}
		} );

		ellipsisItem.classList.toggle( 'en_hidden', !trimCount );
	}
}

function initSmartBreadcrumbs( scopeEl = document ) {
	const smartBreadcrumbsEls = scopeEl.querySelectorAll( '.mdl_breadcrumb' );

	if ( smartBreadcrumbsEls ) {
		smartBreadcrumbsEls.forEach( smartBreadcrumbsEl => {
			smartBreadcrumbsEl.SL_Smart_Breadcrumb ??= new SmartBreadcrumbs( smartBreadcrumbsEl );
		} );
	}
}

export {
	SmartBreadcrumbs as default,
	initSmartBreadcrumbs
}
